// Define the steps for the profile setup process
export const profileSteps = [
  { id: 1, name: 'Basic Info' },
  { id: 2, name: 'Financial Goals' },
  { id: 3, name: 'Risk Assessment' },
  { id: 4, name: 'Current Portfolio' },
  { id: 5, name: 'Investment Preferences' },
  { id: 6, name: 'Profile Overview' }
];
